import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_GSS_CLASSROOM_CHARACTER_ORDER_SETTING = gql`
  mutation updateGssClassroomSettingCharacterOrder(
    $data: [UpdateGssClassroomSettingCharacterOrderInput!]!
  ) {
    updateGssClassroomSettingCharacterOrder(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_GSS_CLASSROOM_CHARACTER_ORDER_SETTING;
